import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSpinnerOverlayComponent } from 'src/app/components/mat-spinner-overlay/mat-spinner-overlay.component';
import { SnackBarService } from '../../services/snack-bar-service.service';
import { AdmRedePostosServices } from '../adm-rede-postos.service';
import { AdmRedePosto } from '../macro-posto.interface';

@Component({
  selector: 'app-editar-master',
  templateUrl: './editar-master.component.html',
  styleUrls: ['./editar-master.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatTableModule,
    MatSelectModule,
    MatSpinnerOverlayComponent,
  ],
})
export class EditarMasterComponent implements OnInit {
  public loading: boolean = false;
  public dialogRef = inject(MatDialogRef<EditarMasterComponent>);

  public isUnchanged = true;
  private originalUserValue: any;
  private snack = inject(SnackBarService);
  @Input() master?: AdmRedePosto;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AdmRedePosto,
    private service: AdmRedePostosServices
  ) {
    this.master = data;
  }

  masterForm: FormGroup = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    idAdmRedePosto: new FormControl('', [Validators.required]),
  });

  private checkIfUnchanged(): void {
    this.isUnchanged =
      JSON.stringify(this.originalUserValue) ===
      JSON.stringify(this.masterForm.getRawValue());
  }

  ngOnInit(): void {
    if (this.master) {
      this.masterForm.patchValue({
        nome: this.master.nome,
        idAdmRedePosto: this.master.idAdmRedePosto,
      });

      this.originalUserValue = this.master.nome;
      this.masterForm.valueChanges.subscribe(() => {
        this.checkIfUnchanged();
      });

      if (!this.master.usuarios) {
        this.master.usuarios = [];
      }
    }
  }

  onCancelar(): void {
    this.dialogRef.close(false);
  }

  onConfirmar(): void {
    this.loading = true;
    const result = this.masterForm.value;

    this.service.editarAdmRedePost(result).subscribe(
      (retorno) => {
        if (retorno && retorno.sucesso) {
          this.dialogRef.close(retorno);
        } else {
          throw new Error('Erro ao editar Adm. Rede');
        }
      },
      (error) => {
        this.loading = false;
        this.snack.flashMessage(
          'Houve um erro ao atualizar o Adm. Rede.',
          ['snackbar-error'],
          'Fechar',
          3000
        );
      },
      () => {
        this.loading = false;
      }
    );
  }
}
